import React from "react";

const StaticData = [
  {
    count: "12+",
    text: "countries served",
  },
  {
    count: "12+",
    text: "countries served",
  },
  {
    count: "12+",
    text: "countries served",
  },
  {
    count: "12+",
    text: "countries served",
  },
];

const CounterSec = ({ counterData = StaticData }) => {
  return (
    <section className="counter-sec">
      <div className="container">
        <div className="row row-gap-25">
          {counterData.map((item, index) => (
            <div className="col-lg-3 col-12" key={index}>
              <div className="counter-box">
                <h3>{item.count}</h3>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CounterSec;
